export default "__VITE_ASSET__2jlmmK7C__"